import * as React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Link, Tooltip } from '@mui/material';
import { VerifiedBadge } from "../components";




function MiniProductInfo({ sku }) {
  const fallbackImage = '/nofigure.png';


  if (!sku) {
    return(
      <></>
    );
  };

  return (
    <Link
      underline="hover"
      component={RouterLink}
      to={`/produto/${sku.id_sku}`}
      state={{ sku }}
      sx={{
        "margin": "auto",
        "display": "flex",
        "flexDirection": "column",
        "alignItems": "center",
        // "justifyContent": "space-between",
        "width": 290,
        "height": 370,
        "borderRadius": "16px",
        "border": 1,
        "borderColor": theme => theme.palette.surface.subtle,
        "cursor": "pointer"
      }}
    >

      <Box sx={{
        display: "flex",
        height: 180,
        width: 240,
        marginX: "8px",
        marginY: "16px"
      }}>
        <img
          src={sku?.images?.[0]?.url_ds || fallbackImage}
          alt={sku.name ?? "Imagem do produto"}
          loading="lazy"
          decoding="async"
          onError={event => {
            if (event.currentTarget.src.endsWith(fallbackImage)) return;
            event.currentTarget.src = fallbackImage;
          }}
          style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain", margin: "auto" }}
        />
      </Box>

      <Box sx={{ 
        marginY: "8px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        height: "150px",
        width: "265px",
       }}>

        <Tooltip title={sku.name ?? "Produto"} placement="top" arrow>
          <Box sx={{
            "fontSize": "20px",
            "fontWeight": "bold",
            "color": theme => theme.palette.text.primary,
            "lineHeight": 1.2,
            "marginBottom": "16px",
            "width": "225px",
            "display": "-webkit-box",
            "WebkitBoxOrient": "vertical",
            "WebkitLineClamp": 3,
            "overflow": "hidden"
          }}>
            {sku.name}
          </Box>
        </Tooltip>

        <VerifiedBadge verified={sku.verified} />

        <Box sx={{
          "fontSize": "13px",
          "fontWeight": "bold",
          "color": theme => theme.palette.text.secondary
        }}>
          GTIN/EAN: {sku.ean?.[0] ?? "-"}
        </Box>

      </Box>

    </Link>
  );
}

export default React.memo(MiniProductInfo);